<template>
    <div>
        <div class="saving" v-if="saving">
            <LoadingSpinner :loading="saving"/>
        </div>
        <div class="row">
            <div class="col-4">
                <EditPanel v-model="block" :selectedPage="page"/>
            </div>
            <div class="col-8">
                <h2>{{ $t("blocks.name") }}</h2>
                <input class="form-control mb-5 mt-2" v-model="name">
                <Calculation v-model="block" :edit="true" :create="true" :showPages="false" @select-page="updatePage"></Calculation>
                <div class="text-center mt-5">
                    <button class="btn btn-primary" @click="save">Uložit</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Calculation from '@/components/Calculation.vue';
import EditPanel from '@/components/EditPanel.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        EditPanel,
        LoadingSpinner
    },
    data() {
        return {
            block: {
                pages: [{structure: []}]
            },
            page: 0,
            saving: false
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/block/" + this.$route.params.id ).then(function (response) {
                this.block = {
                    pages: [response.data.data]
                };
                this.name = response.data.name;
                this.loading = false;
            }.bind(this))
        },
        hide: function () {
            this.$store.getters.api.post("/block/" + this.$route.params.id +"/hide").then(function (response) {
                this.loadData();
            }.bind(this))
        },
        save: function () {
            this.saving = true;
            this.$store.getters.api.put("/block/" + this.$route.params.id + "/edit", {
                "name": this.name,
                "data": this.block.pages[0]
            }).then(function (response) {
                this.loadData();
                this.saving = false;
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>
